import { render, staticRenderFns } from "./ChangeEmailForm.vue?vue&type=template&id=55c96604"
import script from "./ChangeEmailForm.vue?vue&type=script&lang=js"
export * from "./ChangeEmailForm.vue?vue&type=script&lang=js"
import style0 from "./ChangeEmailForm.vue?vue&type=style&index=0&id=55c96604&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports